import React from 'react';
import { SliderInput } from '@meitu/saas-ui';
import { SVG_ATTR_ENUM } from '../../types';

interface IProps {
    title: string;
    pos: number;
    max?: number;
    type: SVG_ATTR_ENUM;
    onClick: (type: SVG_ATTR_ENUM, val: number) => void;
}
const Position: React.FC<IProps> = (props) => {
    const { title, pos, max = 500, onClick, type } = props;
    console.log(max, 'max===');

    return (
        <div className="design-svg-operate__pos">
            <div className="design-svg-title">{title}:</div>
            <SliderInput
                type="horizontal"
                min={0}
                max={max}
                value={pos}
                onChange={(newValue: number) => {
                    onClick?.(type, newValue);
                }}
            ></SliderInput>
        </div>
    );
};
export default React.memo(Position);
